import { cloneDeep, findIndex } from 'lodash';

const _ = { cloneDeep, findIndex };

const initialState = {
    year: 'last',
    playerId: null,
    isLoading: true,
    profile: null,
    completed: null,
    active: null,
    tmsEvents: null,
    singlesResults: null,
    doublesResults: null,
    clubs: null,
    schools: null,
    playedEventCount: 0,
    organisedEventCount: 0,
    feeEarned: 0,
    resultsCount: 0,
    clubsAndSchools: null,
    clubsAndSchoolsState: {
        loading: true,
        completed: false,
        successful: false,
        errorMessage: null,
    },
    eventsState: {
        loading: true,
        completed: false,
        successful: false,
        errorMessage: null,
    },
    memberActionCards: [],
    newDashboard: {},
};

function app(state = initialState, action) {
    switch (action.type) {
        case 'DASHBOARD:SET_PLAYER_ID':
            return {
                ...state,
                playerId: action.playerId,
                isLoading: true,
                data: {},
            };
        case 'DASHBOARD:FETCH_DASHBOARD':
            return {
                ...state,
                isLoading: true,
                isProfileLoaded: false,
            };
        case 'DASHBOARD:FETCH_DASHBOARD_SUCCESS': {
            const { data } = action;
            return {
                ...state,
                error: null,
                isLoading: false,
                profile: data.profile,
                member: data.member,
                memberActionCards: data.memberActionCards,
            };
        }
        case 'DASHBOARD:FETCH_DASHBOARD_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'DASHBOARD:FETCH_DASHBOARD_NEW':
            return {
                ...state,
                isLoading: true,
                isProfileLoaded: false,
            };
        case 'DASHBOARD:FETCH_DASHBOARD_NEW_SUCCESS':
            return {
                ...state,
                error: null,
                isLoading: false,
                newDashboard: {
                    ...action.data,
                    ...state.newDashboard,
                },
            };
        case 'DASHBOARD:FETCH_DASHBOARD_NEW_FAILURE':
            return {
                ...state,
                isLoading: false,
            };
        case 'DASHBOARD:FETCH_DASHBOARD_RESULTS':
            return {
                ...state,
            };
        case 'DASHBOARD:FETCH_DASHBOARD_RESULTS_SUCCESS':
            return {
                ...state,
                error: null,
                newDashboard: {
                    ...state.newDashboard,
                    recentResults: action.data,
                },
            };
        case 'DASHBOARD:FETCH_DASHBOARD_RESULTS_FAILURE':
            return {
                ...state,
            };
        case 'DASHBOARD:FETCH_DASHBOARD_NOTIFICATION':
            return {
                ...state,
            };
        case 'DASHBOARD:FETCH_DASHBOARD_NOTIFICATION_SUCCESS':
            return {
                ...state,
                error: null,
                newDashboard: {
                    ...action.data,
                    ...state.newDashboard,
                },
            };
        case 'DASHBOARD:FETCH_DASHBOARD_NOTIFICATION_FAILURE':
            return {
                ...state,
            };
        case 'DASHBOARD:FETCH_PENDING_RESULTS':
            return {
                ...state,
            };
        case 'DASHBOARD:FETCH_PENDING_RESULTS_SUCCESS':
            return {
                ...state,
                error: null,
                newDashboard: {
                    ...state.newDashboard,
                    pendingResults: action.data,
                },
            };
        case 'DASHBOARD:FETCH_PENDING_RESULTS_FAILURE':
            return {
                ...state,
            };
        case 'DASHBOARD:FETCH_FLEX_LEAGUE_MATCH_CARD':
            return {
                ...state,
            };
        case 'DASHBOARD:FETCH_FLEX_LEAGUE_MATCH_CARD_SUCCESS':
            return {
                ...state,
                error: null,
                newDashboard: {
                    ...state.newDashboard,
                    flexLeagueMatchCards: action.data,
                },
            };
        case 'DASHBOARD:FETCH_FLEX_LEAGUE_MATCH_CARD_FAILURE':
            return {
                ...state,
            };
        case 'DASHBOARD:FETCH_DASHBOARD_CLUBS':
            return {
                ...state,
                clubsAndSchoolsState: {
                    loading: true,
                    complete: false,
                    successful: false,
                    errorMessage: null,
                },
            };
        case 'DASHBOARD:FETCH_DASHBOARD_CLUBS_SUCCESS': {
            const { clubsAndSchools } = action.data;
            const { schools } = action.data;
            const { clubs } = action.data;
            return {
                ...state,
                clubsAndSchools,
                clubs,
                schools,
                clubsAndSchoolsState: {
                    loading: false,
                    complete: true,
                    successful: true,
                    errorMessage: null,
                },
            };
        }
        case 'DASHBOARD:FETCH_DASHBOARD_CLUBS_FAILURE':
            return {
                ...state,
                clubsAndSchoolsState: {
                    loading: false,
                    complete: true,
                    successful: false,
                    errorMessage: 'Failed to retrieve clubs',
                },
            };
        case 'DASHBOARD:FETCH_DASHBOARD_EVENTS':
            return {
                ...state,
                eventsState: {
                    loading: true,
                    complete: false,
                    successful: false,
                    errorMessage: null,
                },
            };
        case 'DASHBOARD:FETCH_DASHBOARD_EVENTS_SUCCESS': {
            const eventData = action.data;
            return {
                ...state,
                completed: eventData.completed,
                active: eventData.active,
                tmsEvents: eventData.tmsEvents,
                playedEventCount: eventData.playedEventCount,
                organisedEventCount: eventData.organisedEventCount,
                feeEarned: eventData.feeEarned,
                resultsCount: eventData.resultsCount,
                singlesResults: eventData.singlesResults,
                doublesResults: eventData.doublesResults,
                eventsState: {
                    loading: false,
                    complete: true,
                    successful: true,
                    errorMessage: null,
                },
            };
        }
        case 'DASHBOARD:FETCH_DASHBOARD_EVENTS_FAILURE':
            return {
                ...state,
                eventsState: {
                    loading: false,
                    complete: true,
                    successful: false,
                    errorMessage: 'Failed to retrieve events',
                },
            };
        case 'DASHBOARD:UPDATE_CONFIRMED_RATING':
            return {
                ...state,
                dashboard: action.data.dashboard,
            };
        case 'DASHBOARD:UPDATE_DASHBOARD':
            return {
                ...state,
                gettingStartedList: action.data.gettingStartedList,
                memberActionCards: action.data.memberActionCards,
            };
        case 'DASHBOARD:UPDATE_GETTING_STARTED_LIST':
            return {
                ...state,
                gettingStartedList: action.data.gettingStartedList,
            };
        case 'POST_SCORE:DELETE_SCORE_SUCCESS': {
            const { resultId } = action.data;
            const newDashboard = _.cloneDeep(state.newDashboard);
            const resultResultsIndex = newDashboard && newDashboard.recentResults ? _.findIndex(newDashboard.recentResults, { id: resultId }) : -1;
            if (newDashboard && newDashboard.recentResults && resultResultsIndex !== -1) {
                newDashboard.recentResults.splice(resultResultsIndex, 1);
            }
            const pendingResultsIndex = newDashboard && newDashboard.pendingResults ? _.findIndex(newDashboard.pendingResults, { id: resultId }) : -1;
            if (newDashboard && newDashboard.pendingResults && pendingResultsIndex !== -1) {
                newDashboard.pendingResults.splice(pendingResultsIndex, 1);
            }
            return {
                ...state,
                newDashboard,
            };
        }
        case 'POST_SCORE:ACCEPT_REJECT_SCORE_SUCCESS': {
            const { resultId } = action.data;
            const { result } = action.data;
            const newDashboard = _.cloneDeep(state.newDashboard);
            const pendingResultsIndex = newDashboard?.pendingResults ? _.findIndex(newDashboard.pendingResults, { id: resultId }) : -1;
            const flexLeagueMatchCardIndex = newDashboard?.flexLeagueMatchCards ? _.findIndex(newDashboard.flexLeagueMatchCards, { resultId }) : -1;
            if (newDashboard?.pendingResults && pendingResultsIndex !== -1) {
                newDashboard.pendingResults.splice(pendingResultsIndex, 1);
                if (!newDashboard.recentResults) {
                    newDashboard.recentResults = [];
                }
                newDashboard.recentResults.splice(0, 0, result);
            }
            if (newDashboard?.flexLeagueMatchCards && flexLeagueMatchCardIndex !== -1) {
                newDashboard.flexLeagueMatchCards.splice(pendingResultsIndex, 1);
                if (!newDashboard.recentResults) {
                    newDashboard.recentResults = [];
                }
                newDashboard.recentResults.splice(0, 0, result);
            }
            return {
                ...state,
                newDashboard,
            };
        }
        default:
            return state;
    }
}

export default app;
